import { render } from "./ContactComponent.vue?vue&type=template&id=39abf4db"
import script from "./ContactComponent.vue?vue&type=script&lang=js"
export * from "./ContactComponent.vue?vue&type=script&lang=js"

import "./ContactComponent.vue?vue&type=style&index=0&id=39abf4db&lang=scss"
script.render = render

export default script